export const journey3 = {
    id: 'journey-3',
    schemaVersion: 2,
    covers: 'Three short stacked lines over one clip — a slogan or a single claim broken across a beat. Far too small for an explanation.',
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 270,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 1],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'clip-length',
                },
            },
        ],
        overlays: [
            {
                kind: 'group',
                id: 'scene-0',
                duration: {
                    kind: 'fixed',
                    frames: 270,
                },
                start: {
                    at: 'frame',
                    value: 0,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.332,
                    width: 0.92,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    gap: 0,
                    align: 'center',
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 132,
                                fontWeight: 300,
                                lineHeight: 1.045,
                                fontStyle: 'italic',
                                strokeWidth: 0,
                                textShadow: '0 2px 18px rgba(0,0,0,0.22)',
                                fontRef: 'cormorant',
                                letterSpacing: -0.02,
                            },
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook2',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 132,
                                fontWeight: 300,
                                lineHeight: 1.045,
                                fontStyle: 'italic',
                                strokeWidth: 0,
                                textShadow: '0 2px 18px rgba(0,0,0,0.22)',
                                fontRef: 'cormorant',
                                letterSpacing: -0.02,
                            },
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'hook3',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 132,
                                fontWeight: 300,
                                lineHeight: 1.045,
                                fontStyle: 'italic',
                                strokeWidth: 0,
                                textShadow: '0 2px 18px rgba(0,0,0,0.22)',
                                fontRef: 'cormorant',
                                letterSpacing: -0.02,
                            },
                            align: 'center',
                        },
                    ],
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        hook: {
            type: 'text',
            maxChars: 24,
            description: 'Line 1 of 3 of ONE quoted headline broken across three stacked lines — a slogan or a single claim about this treatment, said the way a client would say it rather than the way the clinic would. Open with a double quote and do NOT close it; line 3 closes it. e.g. "Start your journey to',
        },
        hook2: {
            type: 'text',
            maxChars: 18,
            description: 'Line 2 of 3, continuing line 1 mid-sentence with no quote marks. It carries the MIDDLE of the phrase and must never read as a statement of its own — the three lines are one sentence. e.g. silky skin with',
        },
        hook3: {
            type: 'text',
            maxChars: 12,
            description: 'Line 3 of 3, ending the headline and closing the quote opened in line 1. This is where the treatment or the result is named, so the phrase resolves into something concrete rather than a mood. e.g. waxing"',
        },
    },
    structure: 'ONE quoted sentence, broken across three stacked lines. `hook`, `hook2` and `hook3` are not three statements — they are one phrase cut at two points, and only line 3 closes the quotation. The source is: "Start your journey to / silky skin with / waxing".',
};
//# sourceMappingURL=journey-3.js.map